import { ComponentRoutes } from "./../../../models/constants/component-routes";
import { ChangeDetectionStrategy, Component, effect, inject, signal } from "@angular/core";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { CommonModule } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatIcon } from "@angular/material/icon";
import { AbTestsStore } from "../../../stores/ab-tests/ab-tests.store";
import { AbTestViewModel } from "@playcharge/common/models/backend/ab-tests/ab-test-view-model";
import { RouterLink } from "@angular/router";

@Component({
    selector: "app-ab-tests",
    standalone: true,
    imports: [CommonModule, MatTableModule, MatIcon, MatButton, MatCheckbox, RouterLink],
    templateUrl: "./ab-tests.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbTestsComponent {
    private _toastrService: ToastrService = inject(ToastrService);

    public abTestsStore = inject(AbTestsStore);

    public displayedColumns = signal(["name", "startDate", "endDate", "active", "actions"]);

    public dataSource: MatTableDataSource<AbTestViewModel> =
        new MatTableDataSource<AbTestViewModel>();

    public ComponentRoutes = ComponentRoutes;

    constructor() {
        effect(() => {
            this.dataSource.data = this.abTestsStore.entities();
        });
    }
}
